import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Amline } from 'src/app/model/quote/amline/amline.model';
import { AmlineService } from '../amline.service';
import { SDTKService } from '../../sdtk/sdtk.service';
import { ExcessProtectService } from '../../excess-protect/excess.service';
import { formatDate } from '@angular/common';
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { QuoteService } from '../../quote.service';
import { environment } from '../../../../environments/environment';
import { LocalStorageService } from 'ngx-webstorage';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-am-quotation',
  templateUrl: './am-quotation.component.html',
  styleUrls: ['./am-quotation.component.css', '../../quote.component.css']
})
export class AmQuotationComponent implements OnInit {
  frmFields: any;
  submitted = false;
  quote_type: number = this.route.snapshot.params.quote_type;
  isNewQuote: boolean = !this.route.snapshot.params.id;
  @Input() authDetails;
  @Input() staticData;
  @Input() selectedIndex;
  @Input() modelObj;
  @Input() apiModelObj;
  @Output() modelObjUpdated = new EventEmitter<Amline>();
  policy_wording_doc_url = "https://s3-eu-west-1.amazonaws.com/msamlin-uat/products/documents/horsebox%20wording%20may%202021.pdf";
  breakdown_wording_doc_url = "https://s3-eu-west-1.amazonaws.com/msamlin-uat/products/documents/horsebox%20breakdown%20wording%20november%202022.pdf";
  ipid_wording_doc_url = "https://s3-eu-west-1.amazonaws.com/msamlin-uat/products/documents/horsebox%20ipid%20may%202021.pdf";
  showAmlinAddonProducts: boolean = environment.showAmlinAddonProducts;
  referAndExit: boolean = false;

  // ST/EP integration
  includeSDTK: boolean = false;
  includeEP: boolean = false;
  sdtkOptions: any[] = [];
  epOptions: any[] = [];
  selectedSdtkOptionId: string = '';
  selectedSdtkOption: any = null;
  selectedEpCoverId: string = '';
  selectedEpOption: any = null;
  sdtkAdjustedPremiumExclIpt: number = 0;
  sdtkAdjustedIpt: number = 0;
  sdtkAdjustedTotalInclIpt: number = 0;
  isSaving: boolean = false;
  saveErrors: any[] = [];
  isQuoteComplete: boolean = false;
  sdtkQuoteId: string = '';
  epQuoteId: string = '';

  constructor(private fb: FormBuilder, private modalService: NgbModal, private as: AmlineService,
    private sdtkService: SDTKService, private epService: ExcessProtectService,
    private router: Router,
    private cdr: ChangeDetectorRef, private route: ActivatedRoute, private quoteService: QuoteService,
    private sessionSt: LocalStorageService, private _snackBar: MatSnackBar) { }

  UK_HB_INSURANCE_COMPANY_ID = '';
  isAdmin = false;
  isStaff = false;
  isBroker = false;
  ngOnInit(): void {
    if (this.sessionSt.retrieve('is_admin')) {
      this.isAdmin = true;
    }
    if (this.sessionSt.retrieve('is_staff')) {
      this.isStaff = true;
    }
    if (this.sessionSt.retrieve('is_broker')) {
      this.isBroker = true;
    }
    this.UK_HB_INSURANCE_COMPANY_ID = environment.UK_HB_INSURANCE_COMPANY_ID;
    this.frmFields = this.fb.group({
      voluntary_excess: ['', Validators.required],
      peliwica_fee: [''],
      breakdown_cover: [''],
      registered_owner: [''],
      commission: ['20', Validators.required],
      broker_admin_fee: ['0', Validators.required],
      discount: ['0', Validators.required],
      refer_reason: ['', Validators.required],
      include_sdtk: [false],
      sdtk_option_id: [''],
      sdtk_storage_location: [''],
      sdtk_is_legal_owner: [''],
      sdtk_has_items_over_1500: [''],
      sdtk_high_value_items: this.fb.array([]),
      sdtk_agree_security: [false],
      sdtk_agree_owner_payment: [false],
      sdtk_agree_no_riding_establishment: [false],
      sdtk_agree_under_insurance: [false],
      include_ep: [false],
      ep_cover_id: [''],
      addon_phone: [''],
      addon_email: [''],
    });

    this.loadSDTKOptions();
    this.loadEPOptions();
  }

  parentModelObj;
  cover_period;
  reference;
  proposer_type;
  isReferred: boolean = false;
  btn_text: string;
  attention_required_text: string;
  ngOnChanges(changes: SimpleChanges) {
    if (this.apiModelObj) {
      this.modelObj = this.apiModelObj.amlin_data.data.attributes.application;
      this.modelObj.id = this.apiModelObj.amlin_data.data.id;
      this.modelObj.reference = this.apiModelObj.amlin_data.data.attributes.reference;
      this.modelObj.status = this.apiModelObj.amlin_data.data.attributes.status;
      this.modelObj.type = this.apiModelObj.type;
      this.modelObj.sequence_number = this.apiModelObj.sequence_number;
      this.modelObj.company_id = this.apiModelObj.company_id;
      this.modelObj.broker_admin_fee = this.apiModelObj.financial_details.broker_admin_fee;
      // Determine if the quote is complete (has a final status)
      const completeStatuses = ['applied'];
      this.isQuoteComplete = completeStatuses.includes(this.modelObj.status);
      // Fetch linked SDTK/EXP quotes by quote_group_id
      if (!this.isNewQuote) {
        let quoteGroupId = this.apiModelObj.quote_group_id || this.apiModelObj.amlin_data?.data?.attributes?.quote_group_id;
        if (quoteGroupId) {
          this.getLinkedQuotes(quoteGroupId);
        }
      }
      this.patchValues();
    }

    if (this.selectedIndex >= 3) {
      let inception_date;
      if (this.modelObj.amlin_data) {
        this.parentModelObj = this.modelObj.amlin_data.data;
        inception_date = this.parentModelObj.attributes.application.inception_date;
        this.reference = this.modelObj.amlin_reference;
        this.proposer_type = this.parentModelObj.attributes.application.proposer.proposer_type;
        if (this.parentModelObj.attributes.premium && this.parentModelObj.attributes.premium.referred) {
          this.isReferred = true;
        }

      } else {
        this.parentModelObj = this.modelObj;
        inception_date = this.modelObj.inception_date;
        if (this.apiModelObj) {
          this.reference = this.apiModelObj.amlin_data.data.attributes.reference;
          if (this.apiModelObj.amlin_data.data.attributes.premium && this.apiModelObj.amlin_data.data.attributes.premium.referred) {
            this.isReferred = true;
          }
        } else {
          this.reference = this.modelObj.reference;
          if (this.modelObj.is_referred) {
            this.isReferred = true;
          }
        }
        this.proposer_type = this.modelObj.proposer.proposer_type;
      }

      let maxDate = new Date(inception_date).setFullYear(new Date(inception_date).getFullYear() + 1);
      let newDate = new Date(new Date(maxDate).getTime() - (24 * 60 * 60 * 1000));
      this.cover_period = formatDate(inception_date, 'dd-MM-yyyy', 'en-US') + ' to ' + formatDate(newDate, 'dd-MM-yyyy', 'en-US');

      this.getPeliwicaPremium();

      this.frmFields.get('broker_admin_fee').setValue(this.modelObj.broker_admin_fee);

    }
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  get f(): { [key: string]: AbstractControl } {
    return this.frmFields.controls;
  }

  vehicle_breakdown = [];
  comp_cover_type: string = '';
  patchValues() {
    this.frmFields.patchValue({
      voluntary_excess: this.modelObj.voluntary_excess,
      commission: 20, //this.modelObj.commission
      broker_admin_fee: this.modelObj.broker_admin_fee,
      discount: (this.modelObj.discount > 0) ? this.modelObj.discount : 0
    });

    let c_cover_type = this.modelObj.vehicles.filter(x => x.cover_type == 'Comprehensive');
    if (c_cover_type.length > 0) {
      this.comp_cover_type = 'Accidental Damage Fire & Theft';
    }

    let tf_cover_type = this.modelObj.vehicles.filter(x => x.cover_type == 'Third Party, Fire and Theft');
    if (tf_cover_type.length > 0) {
      this.comp_cover_type = 'Fire & Theft';
    }

    let t_cover_type = this.modelObj.vehicles.filter(x => x.cover_type == 'Third Party Only');
    if (t_cover_type.length > 0) {
      this.comp_cover_type = 'None';
    }

    if (this.modelObj.vehicles && this.modelObj.vehicles.length > 0) {
      this.modelObj.vehicles.forEach((res) => {
        res.own
      })
    }

  }

  /*
 * HELP TEXT POPUP
 */
  helptext = '';
  helpTextPopup(content, text) {
    this.modalService.open(content, { centered: true });
    this.helptext = text;
  }

  /*
  * Calculate Premium
  */
  ipt: number = 0;
  gross: number = 0; // Principal Amount
  total_prem_inc_ipt: number = 0; // Principal Amount
  total_amount: number = 0;
  vehicle_premiums_key: string = '';
  vehicle_premiums_value: number = 0;
  gross_premium: number = 0;
  premiums: any = '{"referred": null,"ipt": 0,"gross": 0,"breakdown_ipt": 0,"breakdown_gross": 0,"total_amount": 0,"gross_premium":0,"vehicle_premiums": {},"breakdown_premiums": {},"vehicle_excesses": {},"driver_excesses": [ ],"compulsory_excess": 0}';
  breakdown_premiums_arr = [];
  calErrors: any = [];
  hasErrors: boolean = false;
  calculatePremium() {
    this.calErrors = [];
    this.bindPostData();
    let data;
    let obj = this.modelObj;
    if (this.modelObj.amlin_data) {
      obj = this.modelObj.amlin_data.data.attributes.application;
    }
    if (this.apiModelObj && this.apiModelObj.type != 3) {
      obj.policy_id = '';
      obj.effective_date = '';
    }
    obj.voluntary_excess = this.f.voluntary_excess.value;
    data = {
      data: {
        "type": "horsebox-api/quote",
        "attributes": obj
      }

    };
    this.as.calculatePremium(data, this.authDetails)
      .subscribe(
        (res: any) => {
          if (res.meta) {
            this.hasErrors = false;
            this.isReferred = res.meta.referred;
            if (res.meta.referred) {
              this.calErrors = [];
              let msg = { "detail": "Your quote has referred, clicking save and exit will send your quote to the underwriter for review" };
              this.calErrors.push(msg);
              this.btn_text = "Save & Refer to Underwriter";
              this.attention_required_text = "This quote needs to be referred, please click 'Save & Refer to Underwriter' to proceed.";
            } else {
              this.calErrors = [];
              this.btn_text = "Save & Exit";
              this.attention_required_text = "";
            }

            if (res.meta.vehicle_premiums) {
              this.vehicle_premiums_key = Object.keys(res.meta.vehicle_premiums)[0];
              this.vehicle_premiums_value = Number(Object.values(res.meta.vehicle_premiums)[0]);
              this.gross_premium = Number(res.meta.gross);
              this.total_prem_inc_ipt = Number(res.meta.gross) + Number(res.meta.breakdown_gross);
            }
            let broker_admin_fee = (this.modelObj) ? this.modelObj.broker_admin_fee : 0;
            this.frmFields.get('broker_admin_fee').setValue(broker_admin_fee);

            if (this.modelObj && this.modelObj.is_send_email == 1) {
              this.total_amount = this.gross_premium + Number(this.peliwica_fee) + Number(broker_admin_fee) + Number(res.meta.breakdown_gross);
            } else {
              this.total_amount = this.gross_premium + Number(this.peliwica_fee) + Number(res.meta.breakdown_gross);
            }
            this.premiums = res.meta;
            this.breakdown_premiums_arr = [];
            if (res.meta.breakdown_premiums) {
              if (res.meta.breakdown_premiums instanceof Array) {
                res.meta.breakdown_premiums.forEach((res) => {
                  let breakdown = [];
                  breakdown['registration_number'] = Object.keys(res.meta.breakdown_premiums)[0];
                  breakdown['value'] = Number(Object.values(res.meta.breakdown_premiums)[0]);

                  this.breakdown_premiums_arr.push(breakdown);
                })
              } else {
                let breakdown = [];
                breakdown['registration_number'] = Object.keys(res.meta.breakdown_premiums)[0];
                breakdown['value'] = Number(Object.values(res.meta.breakdown_premiums)[0]);
                this.breakdown_premiums_arr.push(breakdown);
              }



              this.breakdown_premiums_arr.forEach((res) => {
                this.modelObj.vehicles.forEach((res1) => {
                  if (res1.registration_number == res.registration_number) {
                    res.is_checked = res1.breakdown_cover;
                  }
                })
              })
            }
          }
        },
        err => {
          this.hasErrors = true;
          this.calErrors = [];
          if (err.error && err.error.errors) {
            this.calErrors = [];
            let msg = { "detail": "Your quote has referred, clicking save and exit will send your quote to the underwriter for review" };
            this.calErrors.push(msg);
            this.btn_text = "Save & Refer to Underwriter";
            this.attention_required_text = "This quote needs to be referred, please click 'Save & Refer to Underwriter' to proceed.";
          }
          let cals = {
            "referred": null,
            "ipt": 0,
            "gross": 0,
            "breakdown_ipt": 0,
            "breakdown_gross": 0,
            "total_amount": 0,
            "gross_premium": 0,
            "vehicle_premiums": {},
            "breakdown_premiums": {},
            "vehicle_excesses": {},
            "driver_excesses": [],
            "compulsory_excess": 0
          }
          this.premiums = cals;

        },);
  }

  /*
  * Get Peliwica Fee
  */
  peliwica_fee: number = 0;
  getPeliwicaPremium() {
    this.quoteService.getLiveStockBrokerCommission(this.modelObj.company_id, environment.AMLINE_ID)
      .subscribe(
        (response: any) => {
          if (response.success) {
            if (this.modelObj.type == 3) {
              this.peliwica_fee = 0;
              this.frmFields.get('peliwica_fee').setValue(0);
            } else {
              this.peliwica_fee = response.result.uw_fee;
              this.frmFields.get('peliwica_fee').setValue(response.result.uw_fee);
            }
          }
          this.calculatePremium();
        },
        (error) => {
          ;
        }
      );
  }

  /*
  * Bind Breakdown Selection
  */
  onBreakdownSelection(event, vehicle_number) {
    this.modelObj.vehicles.forEach((res) => {
      if (res.registration_number == vehicle_number) {
        res.breakdown_cover = event.value;
      }
    })
    this.calculatePremium();
  }

  /*
  * Commission Restrict to 20
  */
  onCommissionChange(event) {
    if (Number(event.target.value) > 20) {
      this.frmFields.get('commission').setValue(20);
    }
    this.calculatePremium();
  }
  /*
  * Broker Commission change modal value
  */
  onBrokerCommissionChange(event) {
    this.modelObj.broker_admin_fee = event.target.value;
    this.calculatePremium();
  }
  /*
  * Discount Restrict to 10
  */
  onDiscountChange(event) {
    if (Number(event.target.value) > 10) {
      this.frmFields.get('discount').setValue(10);
    }
    if (Number(event.target.value) < 0) {
      this.frmFields.get('discount').setValue(0);
    }
    this.calculatePremium();
  }

  /*
  * Bind Owner Name
  */
  onOwnerNameChange(value, vehicle_id) {
    this.modelObj.vehicles.forEach((res) => {
      if (res.id == vehicle_id) {
        res.owner_name = value;
      }
    })
  }

  onReferReasonChange(value: string): void {
    this.frmFields.get('refer_reason').disable();
    if (value != '') {
      this.frmFields.get('refer_reason').enable();
    }
  }
  setReferAndExit(val: boolean): void {
    this.referAndExit = val;
  }

  /*
  * Load ST and EP cover options
  */
  loadSDTKOptions() {
    this.sdtkService.getSDTKRatingOptions('1').subscribe(
      (res: any) => {
        if (res.success) {
          this.sdtkOptions = res.result;
        }
      },
      (error) => { console.error('Failed to load SDTK options', error); }
    );
  }

  loadEPOptions() {
    this.epService.getExcessProtectOptions('1').subscribe(
      (res: any) => {
        if (res.success) {
          this.epOptions = res.result;
        }
      },
      (error) => { console.error('Failed to load EP options', error); }
    );
  }

  sdtkStorageOptions = [
    { id: 1, label: 'Building', icon: 'mdi-home-variant', description: 'Tack room, stable block, or residential building' },
    { id: 2, label: 'Shipping Container', icon: 'mdi-package-variant-closed', description: 'Secure shipping container (25% loading applies)' }
  ];

  onIncludeSDTKChange(checked: boolean) {
    this.includeSDTK = checked;
    const sdtkQuestionFields = [
      'sdtk_storage_location', 'sdtk_is_legal_owner', 'sdtk_has_items_over_1500',
      'sdtk_agree_security', 'sdtk_agree_owner_payment',
      'sdtk_agree_no_riding_establishment', 'sdtk_agree_under_insurance'
    ];
    if (checked) {
      this.frmFields.get('sdtk_option_id').setValidators([Validators.required]);
      this.frmFields.get('sdtk_storage_location').setValidators([Validators.required]);
      this.frmFields.get('sdtk_is_legal_owner').setValidators([Validators.required]);
      this.frmFields.get('sdtk_has_items_over_1500').setValidators([Validators.required]);
      this.frmFields.get('sdtk_agree_security').setValidators([Validators.requiredTrue]);
      this.frmFields.get('sdtk_agree_owner_payment').setValidators([Validators.requiredTrue]);
      this.frmFields.get('sdtk_agree_no_riding_establishment').setValidators([Validators.requiredTrue]);
      this.frmFields.get('sdtk_agree_under_insurance').setValidators([Validators.requiredTrue]);
    } else {
      this.frmFields.get('sdtk_option_id').clearValidators();
      this.frmFields.get('sdtk_option_id').setValue('');
      this.selectedSdtkOption = null;
      this.selectedSdtkOptionId = '';
      sdtkQuestionFields.forEach(f => {
        this.frmFields.get(f).clearValidators();
        this.frmFields.get(f).setValue(f.startsWith('sdtk_agree') ? false : '');
      });
      this.sdtkHighValueItems.clear();
    }
    this.frmFields.get('sdtk_option_id').updateValueAndValidity();
    sdtkQuestionFields.forEach(f => this.frmFields.get(f).updateValueAndValidity());
    this.updateAddonContactValidators();
  }

  onIncludeEPChange(checked: boolean) {
    this.includeEP = checked;
    if (checked) {
      this.frmFields.get('ep_cover_id').setValidators([Validators.required]);
    } else {
      this.frmFields.get('ep_cover_id').clearValidators();
      this.frmFields.get('ep_cover_id').setValue('');
      this.selectedEpOption = null;
      this.selectedEpCoverId = '';
    }
    this.frmFields.get('ep_cover_id').updateValueAndValidity();
    this.updateAddonContactValidators();
  }

  private updateAddonContactValidators() {
    if (this.includeSDTK || this.includeEP) {
      this.frmFields.get('addon_phone').setValidators([Validators.required]);
      this.frmFields.get('addon_email').setValidators([Validators.required, Validators.email]);
    } else {
      this.frmFields.get('addon_phone').clearValidators();
      this.frmFields.get('addon_phone').setValue('');
      this.frmFields.get('addon_email').clearValidators();
      this.frmFields.get('addon_email').setValue('');
    }
    this.frmFields.get('addon_phone').updateValueAndValidity();
    this.frmFields.get('addon_email').updateValueAndValidity();
  }

  onSdtkOptionChange(event) {
    this.selectedSdtkOptionId = event.value;
    this.selectedSdtkOption = this.sdtkOptions.find(o => o.id === this.selectedSdtkOptionId);
    this.recalculateSdtkPremium();
  }

  onSdtkStorageChange(event) {
    this.recalculateSdtkPremium();
  }

  recalculateSdtkPremium() {
    if (!this.selectedSdtkOption) return;
    let basePremium = Number(this.selectedSdtkOption.gross_premium_excl_ipt || 0);
    const storageLocation = this.frmFields.get('sdtk_storage_location').value;
    // Apply 25% loading for Shipping Container (id: 2)
    if (storageLocation === 2) {
      basePremium = basePremium + (basePremium * 25 / 100);
    }
    const ipt = basePremium * 12 / 100;
    this.sdtkAdjustedPremiumExclIpt = basePremium;
    this.sdtkAdjustedIpt = ipt;
    this.sdtkAdjustedTotalInclIpt = basePremium + ipt;
  }

  onEpCoverChange(event) {
    this.selectedEpCoverId = event.value;
    this.selectedEpOption = this.epOptions.find(o => o.id === this.selectedEpCoverId);
  }

  // --- S&T High Value Items ---
  get sdtkHighValueItems(): FormArray {
    return this.frmFields.get('sdtk_high_value_items') as FormArray;
  }

  createSdtkItemGroup(item?: any): FormGroup {
    return this.fb.group({
      make: [item?.make || '', Validators.required],
      model: [item?.model || '', Validators.required],
      type: [item?.type || '', Validators.required],
      colour: [item?.colour || '', Validators.required],
      size: [item?.size || '', Validators.required],
      value: [item?.value || '', [Validators.required, Validators.min(1500)]]
    });
  }

  addSdtkItem() {
    this.sdtkHighValueItems.push(this.createSdtkItemGroup());
  }

  removeSdtkItem(index: number) {
    this.sdtkHighValueItems.removeAt(index);
  }

  onSdtkHighValueChange(event: any) {
    const value = event.value;
    if (value === true && this.sdtkHighValueItems.length === 0) {
      this.addSdtkItem();
    } else if (value === false) {
      this.sdtkHighValueItems.clear();
    }
  }

  get sdtkTotalHighValueItems(): number {
    return this.sdtkHighValueItems.controls.reduce((sum, ctrl) => {
      const val = ctrl.get('value')?.value || 0;
      return sum + Number(val);
    }, 0);
  }

  get sdtkCoverLimitSelected(): number {
    if (!this.selectedSdtkOption) return 0;
    return Number(this.selectedSdtkOption.sum_insured || 0);
  }

  isSdtkTotalOverLimit(): boolean {
    return this.sdtkTotalHighValueItems > this.sdtkCoverLimitSelected && this.sdtkCoverLimitSelected > 0;
  }

  /*
  * Get combined total including ST/EP
  */
  getCombinedTotal(): number {
    let total = this.total_amount;
    if (this.includeSDTK && this.selectedSdtkOption) {
      total += Number(this.sdtkAdjustedTotalInclIpt || 0);
    }
    if (this.includeEP && this.selectedEpOption) {
      total += Number(this.selectedEpOption.rate_incl_ipt || 0);
    }
    return total;
  }

  // Fetch linked SDTK and EXP quotes by quote_group_id
  getLinkedQuotes(quoteGroupId: string) {
    this.as.getQuotesByGroupId(quoteGroupId).subscribe(
      (res: any) => {
        if (res.success && res.result) {
          res.result.forEach((quote: any) => {
            if (quote.product_id === environment.SADDLERY_TACK_PROTECT_ID) {
              this.sdtkQuoteId = quote.quote_id;
            }
            if (quote.product_id === environment.EXCESS_PROTECT_ID) {
              this.epQuoteId = quote.quote_id;
            }
          });
        }
      },
      (error) => {
        console.error('Failed to load linked quotes', error);
      }
    );
  }

  /*
  * Save Quote Details
  */
  onSubmit(content, referral) {
    this.submitted = true;
     this.frmFields.get('refer_reason').disable();

    if (!this.frmFields.valid) {
      return false;
    }

    // Check owner_name is filled for all vehicles where owner is required
    let ownerNameMissing = this.modelObj.vehicles.some(v => v.owner && (!v.owner_name || v.owner_name.trim() === ''));
    if (ownerNameMissing) {
      return false;
    }

    if (this.hasErrors) {
      return false;
    }

    if (this.modelObj.type == 2) {
      this.modelObj.policy_id = null;
      this.modelObj.effective_date = null;
    }

    if (this.isReferred) {
      this.modalService.open(referral, { centered: true });
    } else {
      this.saveQuote(content);
    }
  }

  bindPostData() {
    let formData = this.frmFields.value;
    this.modelObj.voluntary_excess = formData.voluntary_excess;
    this.modelObj.commission = 20; //formData.commission;
    this.modelObj.discount = (formData.discount > 0) ? formData.discount : 0;
    this.modelObj.peliwica_fee = formData.peliwica_fee;
  }

  saveQuote(content) {
    this.isSaving = true;
    this.saveErrors = [];

    let obj;
    if (this.modelObj.amlin_data) {
      obj = this.modelObj.amlin_data.data.attributes.application;
    } else {
      obj = this.modelObj;
    }

    let formData = this.frmFields.value;
    obj.voluntary_excess = formData.voluntary_excess;
    obj.commission = formData.commission;
    obj.broker_admin_fee = formData.broker_admin_fee;
    obj.discount = formData.discount;
    obj.peliwica_fee = formData.peliwica_fee;

    let refer_reason = '';
    if (this.isAdmin || this.isStaff) {
      if (this.referAndExit) {
        this.isReferred = true;
        refer_reason = this.frmFields.get('refer_reason').value;
        this.frmFields.get('refer_reason').disable();
        if (refer_reason == '') {
          this.frmFields.get('refer_reason').enable();
          this.isSaving = false;
          return;
        }
      }
    }

    // Build Amlin payload (same as before)
    let amlinData = {
      data: {
        "type": this.modelObj.type,
        "attributes": obj,
        "id": this.modelObj.id,
        "sequence_number": this.modelObj.sequence_number,
        "broker_id": this.modelObj.broker_id,
      },
      meta: {
        "refer": this.isReferred,
        "refer_reason": refer_reason,
      },
    };

    // Build ST payload if checked
    let stData = null;
    if (this.includeSDTK && this.selectedSdtkOptionId) {
      stData = this.buildSTPayload();
    }

    // Build EP payload if checked
    let epData = null;
    if (this.includeEP && this.selectedEpCoverId) {
      epData = this.buildEPPayload();
    }

    // If no ST/EP, use the existing single endpoint for backward compatibility
    if (!stData && !epData) {
      this.as.saveQuote(amlinData)
        .subscribe(
          (res: any) => {
            this.handleAmlinSaveResponse(res, content);
            this.isSaving = false;
          },
          (err) => {
            this.isSaving = false;
            this._snackBar.open('Error saving quote. Please try again.', '', {
              duration: 5000,
              panelClass: 'text-danger'
            });
          });
    } else {
      // Use combined endpoint
      let combinedPayload = {
        amlin_data: amlinData,
        st_data: stData,
        ep_data: epData,
      };
      this.as.saveCombinedQuote(combinedPayload)
        .subscribe(
          (res: any) => {
            if (res.success) {
              // Show warnings for partial failures
              if (res.errors && res.errors.length > 0) {
                this.saveErrors = res.errors;
                let warningMsg = res.errors.map(e => e.product + ': ' + e.message).join('; ');
                this._snackBar.open('Quote saved with warnings: ' + warningMsg, '', {
                  duration: 8000,
                  panelClass: 'text-warning'
                });
              }
              this.modalService.open(content, { centered: true });
              this.helptext = 'Data Saved.';
              this.modelObjUpdated.emit(this.modelObj);
              // Navigate to Amlin quote view (primary quote)
              let amlinId = res.result?.amlin?.result?.quote_data?.quote_versions?.[0]?.amlin_id;
              if (amlinId) {
                this.router.navigateByUrl("/amline/quote-details/" + amlinId);
              }
            } else {
              this._snackBar.open(res.message || 'Failed to save combined quotes.', '', {
                duration: 5000,
                panelClass: 'text-danger'
              });
            }
            this.modalService.dismissAll();
            this.isSaving = false;
          },
          (err) => {
            this.isSaving = false;
            this._snackBar.open('Error saving combined quotes. Please try again.', '', {
              duration: 5000,
              panelClass: 'text-danger'
            });
          });
    }
  }

  private handleAmlinSaveResponse(res: any, content) {
    if (res.success) {
      this.modalService.open(content, { centered: true });
      this.helptext = 'Data Saved.';
      this.modelObjUpdated.emit(this.modelObj);
      this.router.navigateByUrl("/amline/quote-details/" + res.result.quote_data.quote_versions[0].amlin_id);
    } else {
      this._snackBar.open(res.message, '', {
        duration: 5000,
        panelClass: 'text-danger'
      });
    }
    this.modalService.dismissAll();
  }

  /*
  * Build ST payload from Amlin data
  */
  private buildSTPayload() {
    let proposer = this.getProposerFromAmlin();
    let address = this.getAddressFromAmlin();

    // Build vehicle_details from high-value items if user selected "Yes"
    const hasHighValue = this.frmFields.get('sdtk_has_items_over_1500').value === true || this.frmFields.get('sdtk_has_items_over_1500').value === 'true';
    let vehicles = [];
    if (hasHighValue) {
      vehicles = this.sdtkHighValueItems.controls.map(ctrl => ({
        make: ctrl.get('make').value,
        model: ctrl.get('model').value,
        type: ctrl.get('type').value,
        colour: ctrl.get('colour').value,
        size: ctrl.get('size').value,
        value: Number(ctrl.get('value').value)
      }));
    }

    return {
      "quote_data": {
        "type": 1,
        "id": null,
        "broker_id": this.modelObj.broker_id || null,
        "company_id": this.modelObj.company_id,
        "sequence_number": 0,
        "policy_start_date": this.getInceptionDate(),
        "sdtk_option_id": this.selectedSdtkOptionId,
        "policy_holder": proposer,
        "address": address,
        "vehicle_details": vehicles,
        "questions": {
          has_items_over_1500: this.frmFields.get('sdtk_has_items_over_1500').value === true || this.frmFields.get('sdtk_has_items_over_1500').value === 'true' ? 1 : 0,
          is_legal_owner: this.frmFields.get('sdtk_is_legal_owner').value === true || this.frmFields.get('sdtk_is_legal_owner').value === 'true' ? 1 : 0,
          storage_location: this.frmFields.get('sdtk_storage_location').value || 1,
          confirm_security_requirements: this.frmFields.get('sdtk_agree_security').value ? 1 : 0,
          confirm_non_ownership_claim_terms: this.frmFields.get('sdtk_agree_owner_payment').value ? 1 : 0,
          confirm_not_used_for_hiring: this.frmFields.get('sdtk_agree_no_riding_establishment').value ? 1 : 0,
          confirm_under_insurance_clause: this.frmFields.get('sdtk_agree_under_insurance').value ? 1 : 0,
        },
        "send_email": 1,
      }
    };
  }

  /*
  * Build EP payload from Amlin data
  */
  private buildEPPayload() {
    let proposer = this.getProposerFromAmlin();
    let address = this.getAddressFromAmlin();
    let vehicles = this.getVehiclesFromAmlin();

    return {
      "quote_data": {
        "type": 1,
        "id": null,
        "broker_id": this.modelObj.broker_id || null,
        "company_id": this.modelObj.company_id,
        "sequence_number": 0,
        "policy_start_date": this.getInceptionDate(),
        "excess_protect_cover_id": this.selectedEpCoverId,
        "policy_holder": proposer,
        "address": address,
        "vehicle_details": vehicles,
        "send_email": 1,
      },
      "meta": { "refer": false, "refer_reason": "" }
    };
  }

  private getProposerFromAmlin() {
    let application = this.getAmlinApplication();
    let p = application.proposer;
    let formData = this.frmFields.value;
    return {
      "title": p.title || '',
      "first_name": p.first_name || '',
      "last_name": p.last_name || '',
      "email": formData.addon_email || p.email || '',
      "phone": formData.addon_phone || p.phone || '',
      "dob": p.dob || null,
      "company_name": p.company_name || '',
      "trading_name": p.trading_name || '',
      "proposer_type": p.proposer_type || 'individual',
      "year": p.year || null,
      "micro_enterprise": p.micro_enterprise || false,
    };
  }

  private getAddressFromAmlin() {
    let application = this.getAmlinApplication();
    let a = application.proposer.address;
    return {
      "address1": a.line1 || '',
      "address2": a.line2 || '',
      "address3": a.line3 || '',
      "address4": '',
      "address5": '',
      "city": a.county || a.town || '',
      "country": "UK",
      "postcode": a.postcode || '',
    };
  }

  private getVehiclesFromAmlin() {
    let application = this.getAmlinApplication();
    return application.vehicles || [];
  }

  private getInceptionDate() {
    let application = this.getAmlinApplication();
    return application.inception_date;
  }

  private getAmlinApplication() {
    if (this.modelObj.amlin_data) {
      return this.modelObj.amlin_data.data.attributes.application;
    }
    return this.modelObj;
  }

}
